"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Modal = _interopRequireWildcard(require("./Modal.styled"));

var _utils = require("../../utils/utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var XSvg = function XSvg(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("title", null, "X Remove Delete Close Cross Multiply"), _react["default"].createElement("path", {
    fill: "#25292D",
    d: "M5.147 5.146a.5.5 0 0 1 .707 0l2.13 2.131 2.131-2.13a.5.5 0 0 1 .638-.058l.07.057a.5.5 0 0 1 0 .708L8.69 7.984l2.132 2.131a.5.5 0 0 1 .058.638l-.058.07a.5.5 0 0 1-.707 0L7.984 8.69l-2.13 2.133a.5.5 0 0 1-.638.057l-.07-.057a.5.5 0 0 1 0-.708l2.131-2.131-2.13-2.13a.5.5 0 0 1-.058-.638z"
  }));
};

XSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};
var modalStack = [];

var Modal = function Modal(_ref) {
  var children = _ref.children,
      onClose = _ref.onClose;
  var modalContainerRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (!(0, _utils.scrollLocked)()) {
      (0, _utils.scrollLock)();
      return function () {
        (0, _utils.scrollUnlock)();
      };
    }
  }, []); // Handle exit using escape key via eventListener. If enter key is processed here for closing modal, we have problems
  // when enter key press is required for other things like a button (e.g. login modal button).

  var handleKeyDown = function handleKeyDown(e) {
    if (e.keyCode === 27 && onClose) {
      if (modalStack[modalStack.length - 1] == modalContainerRef) {
        onClose(e);
      }
    }
  }; // Handle exit using enter key via onKeyDown.


  var handleExit = function handleExit(e) {
    if (e.keyCode === 13 && onClose) {
      onClose(e);
    }
  };

  (0, _react.useEffect)(function () {
    window.addEventListener("keydown", handleKeyDown);
    modalStack.push(modalContainerRef);
    var focusableElements = modalContainerRef.current.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    focusableElements[0].focus();
    return function () {
      window.removeEventListener("keydown", handleKeyDown);
      modalStack.splice(modalStack.indexOf(modalContainerRef), 1);
    };
  }, [handleKeyDown]);
  return _react["default"].createElement(_Modal["default"], {
    role: "dialog",
    "aria-modal": "true",
    className: "modal-component"
  }, _react["default"].createElement(_Modal.GlobalStyle, null), _react["default"].createElement("div", {
    className: "modal-filter",
    onClick: onClose
  }), _react["default"].createElement("div", {
    className: "modal-container",
    ref: modalContainerRef
  }, _react["default"].createElement("div", {
    className: "close-modal"
  }, _react["default"].createElement("span", {
    tabIndex: "0",
    onClick: onClose,
    onKeyDown: handleExit
  }, _react["default"].createElement(XSvg, null))), _react["default"].createElement("div", {
    className: "modal-content"
  }, children)));
};

var _default = Modal;
exports["default"] = _default;